import { render, staticRenderFns } from "./third.vue?vue&type=template&id=a512a6c6&scoped=true&"
var script = {}
import style0 from "./third.vue?vue&type=style&index=0&id=a512a6c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a512a6c6",
  null
  
)

export default component.exports